
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Bank from '@/extend/classes/Bank';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeBank' })

export default class storeBank extends VuexModule {
  // States
  private reccords: Bank[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get bankLoading (): boolean {
    return this.dataLoading;
  }
  private get bankRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get bankLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewBank() {
    return (): Bank => { 
      return this.getBank(0, true);
    }
  }

  
  public get getBank () {
    return (id: number, canCreate = false): Bank => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Bank can't be 0")
        return new Bank();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Bank();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Bank.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromBank(data.reccords[0] as Bank);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listBank (): Bank[] {
    return this.reccords;
  }

  public get listConfigBank (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mBankRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mBankClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mBankLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mBankLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Bank.fromJson(reccord as Bank));
    })
    Bank.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mBankConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mBankCreated (obj: Bank): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareBank(obj)) {
          api.fromBank(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareBank(obj)) {
            api.fromBank(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mBankUpdated (obj: Bank): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareBank(obj)) {
          api.fromBank(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mBankDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerBank (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.bankRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerBank(this.bankCreated, this.bankUpdated, this.bankDeleted);
          this.mBankRegistered();
        } else {
          setTimeout(() => resolve(this.registerBank(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.bankLoading && !this.bankLoaded) {
          this.mBankLoading(true);
          return Bank.list(filter)
            .then((data: ListData) => {
              this.mBankLoaded(data);
              this.mBankLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredBank (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.bankLoading) {
        this.mBankLoading(true);
        return Bank.list(filter)
          .then((data: ListData) => {
            this.mBankLoaded(data);
            this.mBankLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createBank (obj: Bank): Promise<Bank> {
    return new Promise((resolve, reject) => {
      return Bank.fromJson(obj).createForStoreBank()
        .then((reccords) => {
          this.mBankCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateBank (obj: Bank): Promise<Bank> {
    return new Promise((resolve, reject) => {
      return Bank.fromJson(obj).updateForStoreBank()
        .then((reccords) => {
          this.mBankUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteBank (obj: Bank): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return Bank.fromJson(obj).deleteForStoreBank()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mBankDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private bankCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mBankConfigUpdated(config)
    const obj = objConfig.obj as Bank;
    this.mBankCreated(Bank.fromJson(obj));
  }

  @Action
  private bankUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mBankConfigUpdated(config)
    const obj = objConfig.obj as Bank;
    this.mBankUpdated(Bank.fromJson(obj));
  }

  @Action
  private bankDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Bank;
    this.mBankDeleted(obj.id);
  }
}
